import React from 'react'
import { Image } from 'newComponents'
import './styles.scss'

import togglemultiple from '../../../images/customers/toggle-multiple.png'
import browsermobile from '../../../images/customers/browser-mobile.png'
import server from '../../../images/customers/server.png'

const Accolades = () => {
  const accolades = [
    { image: togglemultiple, heading: '6 Trillion Feature Flags', subheading: 'Served to users daily.' },
    { image: browsermobile, heading: '14 Million Devices & Browsers', subheading: 'Served world-wide daily.' },
    { image: server, heading: '3 Million Servers', subheading: 'Reached world-wide daily.' }
  ]

  return (
    <section className="accolades">
      <div className="container">
        <div className="accolades-title-info">
          <h2 className="accolades-title">Built for Scale</h2>
          <p className="accolades-subtitle">We can handle your biggest requests.</p>
        </div>
        <div className="accolade">
          {accolades.map((accolade) => (
            <div className="accolade-item" key={accolade.heading}>
              <Image className="accolade-image" image={accolade.image} />
              <h3 className="accolade-heading">{accolade.heading}</h3>
              <p className="accolade-subheading">{accolade.subheading}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Accolades
